<canvas id="canvasBar">{{chart}}</canvas>